const paths = {
	info_about: 'infoAbout',
	howto: 'howto',
	sources: 'sources',
	explorators: 'explorators',
	kudosGoTo: 'kudosGoTo',
	contact: 'contact',
	media: 'media',
	moreLinks: 'moreLinks',
};

export default async (id) => {
	try {
		const { default: markup } = await import(
			/* webpackChunkName: "side-panel-card-lazy" */
			/* webpackMode: "lazy-once" */
			`./${paths[id]}.html`
		);
		return markup;
	} catch (error) {
		console.error(error);
	}
};
